// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__pV_Uc","info":"UpdateTermsInfo_info__eSmlC"};